
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";

//Importing the pages
import Home from "../Pages/Home";
import Services from "../Pages/Services";
import Contact from "../Pages/Contact";
import Reviews from "../Pages/Reviews";

//Importing the stylesheet
import "../style.scss";

const App: React.FC = () => {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Reviews" element={<Reviews />} />
            <Route path="/Contact" element={<Contact />} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
